module.exports = __webpack_public_path__ + "static/media/arrow-up-right.6d040f72.svg";